export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyDjxaynlV7h66md8O2v0g4Sf_zD-iF5Swg",
    authDomain: "intrapro-34kideas.firebaseapp.com",
    databaseURL: "https://intrapro-34kideas.firebaseio.com",
    projectId: "intrapro-34kideas",
    storageBucket: "intrapro-34kideas.appspot.com",
    messagingSenderId: "1096270661262"
  },
  finishSignUpUrl: 'https://intrapro-34kideas.firebaseapp.com/finishSignUp/',
  dominioUrl: 'https://intrapro-34kideas.firebaseapp.com'
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts